import { render, staticRenderFns } from "./ExportSamplesModal.vue?vue&type=template&id=0c245cda"
import script from "./ExportSamplesModal.vue?vue&type=script&lang=js"
export * from "./ExportSamplesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports